export default __webpack_public_path__ + "static/media/img-color-check-b.ed794d3b.svg";